import { Box, SxProps, Theme } from "@mui/material";
import theme from "theme";
import { P } from "theme/typography";
import React from "react";

interface LabeledBorderBoxProps {
  children: React.ReactNode;
  label: string;
  sx?: SxProps<Theme>;
  backgroundColor?: string;
}
export const LabeledBorderBox = (props: LabeledBorderBoxProps) => {
  const backgroundColor = props && props.backgroundColor ? props.backgroundColor : "#fff";
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        mt: 2,
        p: 1,
        border: `1px solid ${theme.palette.grey[50]}`,
        position: "relative",
        ...props.sx,
      }}>
      <P
        variant="overline"
        sx={{
          color: "grey.400",
          backgroundColor: backgroundColor,
          position: "absolute",
          left: 16,
          top: -8,
          display: "block",
          px: 1,
        }}>
        {props.label}
      </P>
      {props.children}
    </Box>
  );
};
